export interface Option {
  id?: string;
  text: string;
  val: string;
}
